import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import arrowRight from "../../assets/arrow_right.svg";
import {
  cardColumnSx,
  cardContentSx,
  cardLeftSx,
  cardRightSx,
  cardTitleSx,
  labelArrowSx,
} from "./PlatformFeaturesSection.sx";
import { FeatureCard } from "./PlatformFeaturesSection.config";

export interface PlatformFeatureCardProps {
  card: FeatureCard;
  index: number;
}

export const PlatformFeatureCard = ({
  card,
  index,
}: PlatformFeatureCardProps) => {
  return (
    <Box sx={index % 2 === 0 ? cardLeftSx : cardRightSx}>
      {/* Card Title */}
      <Typography sx={cardTitleSx}>{card.title}</Typography>

      {/* Card Content */}
      <Box sx={cardContentSx}>
        {/* Features Column */}
        <Box sx={cardColumnSx}>
          <Stack direction="row" alignItems="center" gap="0.5rem">
            <Box component="img" src={arrowRight} alt="" sx={labelArrowSx} />
            <Typography variant="body2">Features:</Typography>
          </Stack>
          <Stack direction="column" gap="0.1rem">
            {card.features.map((feature) => (
              <Typography variant="body2" key={feature}>
                {feature}
              </Typography>
            ))}
          </Stack>
        </Box>

        {/* Benefit Column */}
        <Box sx={cardColumnSx}>
          <Stack direction="row" alignItems="center" gap="0.5rem">
            <Box component="img" src={arrowRight} alt="" sx={labelArrowSx} />
            <Typography variant="body2">Benefit:</Typography>
          </Stack>
          <Typography variant="body2">{card.benefit}</Typography>
        </Box>
      </Box>
    </Box>
  );
};
